var combineEventHandlers = function combineEventHandlers(ownPropHandler, contextHandler) {
  return ownPropHandler && contextHandler ? function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return ownPropHandler.apply(void 0, [contextHandler].concat(args));
  } : contextHandler || ownPropHandler;
};

export default combineEventHandlers;